import React, { Component } from "react";

const defaultAppContext = {
  drawerIsOpen: false,
  toggleDrawer: () => {}
};

export const AppContext = React.createContext(defaultAppContext);

class AppProvider extends Component {
  static Consumer = AppContext.Consumer;

  toggleDrawer = () => {
    this.setState({ drawerIsOpen: !this.state.drawerIsOpen });
  };

  state = {
    drawerIsOpen: false,
    toggleDrawer: this.toggleDrawer
  };

  render() {
    return <AppContext.Provider value={this.state} {...this.props} />;
  }
}

export default AppProvider;
